export const extractWarning = (response) => {
  const { similarityReport, copyscape } = response;
  const details = [];

  if (similarityReport?.exampleOne?.error) {
    details.push('Could not generate Similarity Report for Example 1');
  }
  if (similarityReport?.exampleTwo?.error) {
    details.push('Could not generate Similarity Report for Example 2');
  }
  if (copyscape?.error) {
    details.push(`Copyscape issue: ${copyscape.error}`);
  }

  if (details.length === 0) {
    return null;
  }

  return {
    label: 'Pay attention',
    details: details.join(', ')
  };
};
